import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { styled } from "~/common/mui";

interface ExpandedIconProps {
  expanded?: boolean;
}

export const ExpandedIcon = styled(ArrowDropDownIcon, {
  shouldForwardProp: (prop) => prop !== "expanded",
})<ExpandedIconProps>(({ theme, expanded }) => ({
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
}));
